module.exports = __webpack_public_path__ + "img/sarah.82c737cb.jpg";